import { render } from "./PersonSectionBasic.vue?vue&type=template&id=03a01497"
import script from "./PersonSectionBasic.vue?vue&type=script&lang=js"
export * from "./PersonSectionBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__